var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100"},[(_vm.spinnerShow)?_c('b-spinner',{staticClass:"spinner"}):_vm._e(),_c('div',{staticClass:"container w-100"},[_c(_vm.block,{tag:"component",on:{"spinner":function($event){_vm.spinnerShow = false}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }